import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Stack,
  Paper,
  Fade,
  Grow,
  Zoom,
  Chip,
  alpha,
  useTheme,
  useMediaQuery,
  Button,
  Divider,
} from "@mui/material";
import {
  TrackChanges as TargetIcon,
  Visibility as VisibilityIcon,
  People as PeopleIcon,
  EmojiEvents as AwardIcon,
  History as HistoryIcon,
  Flag as FlagIcon,
  Groups as TeamIcon,
  CheckCircle as CheckIcon,
  ArrowForward as ArrowIcon,
  LocalShipping as TruckIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  CorporateFare as CorporateIcon,
} from "@mui/icons-material";

// Import your image
import aboutImage from "../assets/images/a.png";

const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Brand colors
  const brandColors = {
    green: '#a6ce39',
    black: '#050606',
    orange: '#ec7723',
    white: '#ffffff'
  };

  const values = [
    {
      icon: <TargetIcon />,
      title: "RESPONSIVENESS",
      description: "We work closely with customers to understand their needs and develop efficient solutions",
      features: ["Customer-centric", "Efficient Solutions", "Cost-effective"]
    },
    {
      icon: <AwardIcon />,
      title: "QUALITY SERVICE",
      description: "Delivering high-quality service with solid record in improving customer productivity",
      features: ["High Standards", "Productivity Focus", "Industry Partners"]
    },
    {
      icon: <PeopleIcon />,
      title: "COMMUNICATION",
      description: "Setting proper expectations and maintaining transparent collaboration",
      features: ["Transparent", "Collaborative", "Proactive"]
    },
    {
      icon: <VisibilityIcon />,
      title: "CONTINUOUS IMPROVEMENT",
      description: "Applying lean practices to eliminate waste and provide better service",
      features: ["Lean Practices", "Innovation", "Growth Focused"]
    },
  ];

  const staff = [
    { 
      name: "MR MFANAWENKOSI SIFUNDZA", 
      role: "DIRECTOR", 
      phone: "+268 7602 1597",
      color: brandColors.orange 
    },
    { 
      name: "MISS MAYIBONGWE MAGONGO", 
      role: "RISK MANAGER", 
      phone: "+268 7677 3299",
      color: brandColors.green 
    },
    { 
      name: "MR SITHEMBISO GININDZA", 
      role: "OPERATIONS MANAGER", 
      phone: "+268 7602 2974",
      color: brandColors.orange 
    },
    { 
      name: "MISS BONISILE MATSEBULA", 
      role: "OFFICE ADMIN", 
      phone: "+268 7812 2941",
      color: brandColors.green 
    },
  ];

  const corporateInfo = [
    { icon: <CorporateIcon />, label: "Business Registration", value: "R7/61624" },
    { icon: <CorporateIcon />, label: "VAT Registration", value: "106 842 168" },
    { icon: <PhoneIcon />, label: "Telephone", value: "+268 2518 5080" },
    { icon: <EmailIcon />, label: "Email", value: "transcologistics26@gmail.com" },
  ];

  return (
    <>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          color: brandColors.white,
          py: { xs: 12, md: 18 },
          textAlign: "center",
          minHeight: { xs: "70vh", md: "85vh" },
          display: "flex",
          alignItems: "center",
          backgroundImage: `linear-gradient(135deg, ${alpha(brandColors.black, 0.9)} 0%, ${alpha(brandColors.black, 0.8)} 100%), url(${aboutImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundBlendMode: "overlay",
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Fade in timeout={800}>
            <Box>
              <Chip
                label="EST. 2021"
                icon={<HistoryIcon />}
                sx={{
                  mb: 4,
                  backgroundColor: alpha(brandColors.green, 0.2),
                  color: brandColors.green,
                  border: `1px solid ${alpha(brandColors.green, 0.3)}`,
                  px: 3,
                  py: 1.5,
                  fontSize: "0.9rem",
                  fontWeight: 700,
                  '& .MuiChip-icon': {
                    color: brandColors.green,
                  }
                }}
              />

              <Typography
                variant="h1"
                gutterBottom
                sx={{
                  fontWeight: 900,
                  mb: 3,
                  fontSize: { xs: "2.8rem", md: "4.5rem" },
                  background: `linear-gradient(135deg, ${brandColors.white} 0%, ${brandColors.green} 100%)`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  lineHeight: 1.1,
                  letterSpacing: '-0.02em',
                }}
              >
                TRANSCO LOGISTICS
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  mb: 4,
                  color: brandColors.orange,
                  fontWeight: 700,
                  fontStyle: 'italic',
                }}
              >
                "Steering You Towards Success"
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  maxWidth: 800,
                  mx: "auto",
                  mb: 5,
                  color: alpha(brandColors.white, 0.9),
                  lineHeight: 1.6,
                  fontWeight: 400,
                  fontSize: { xs: "1.1rem", md: "1.3rem" },
                }}
              >
                A sister company of HYDROPCE HYDRAULICS AND PNEUMATICS ENGINEERING
              </Typography>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="center"
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Chip
                  label="SINCE 2021"
                  icon={<HistoryIcon />}
                  sx={{
                    backgroundColor: alpha(brandColors.orange, 0.2),
                    color: brandColors.orange,
                    border: `1px solid ${alpha(brandColors.orange, 0.3)}`,
                    fontWeight: 600,
                    px: 3,
                    py: 1.5,
                  }}
                />
                <Chip
                  label="15+ FLEET VEHICLES"
                  icon={<TruckIcon />}
                  sx={{
                    backgroundColor: alpha(brandColors.green, 0.2),
                    color: brandColors.green,
                    border: `1px solid ${alpha(brandColors.green, 0.3)}`,
                    fontWeight: 600,
                    px: 3,
                    py: 1.5,
                  }}
                />
                <Chip
                  label="14+ STAFF MEMBERS"
                  icon={<TeamIcon />}
                  sx={{
                    backgroundColor: alpha(brandColors.orange, 0.2),
                    color: brandColors.orange,
                    border: `1px solid ${alpha(brandColors.orange, 0.3)}`,
                    fontWeight: 600,
                    px: 3,
                    py: 1.5,
                  }}
                />
              </Stack>
            </Box>
          </Fade>
        </Container>
      </Box>

      {/* Company Overview */}
      <Container maxWidth="lg" sx={{ py: { xs: 10, md: 15 } }}>
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Fade in timeout={600}>
              <Box>
                <Box display="flex" alignItems="center" gap={2} mb={4}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: 3,
                      bgcolor: brandColors.orange,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: brandColors.white,
                      boxShadow: `0 8px 24px ${alpha(brandColors.orange, 0.3)}`,
                    }}
                  >
                    <CorporateIcon sx={{ fontSize: 32 }} />
                  </Box>
                  <Typography variant="h2" fontWeight={900} color={brandColors.black}>
                    COMPANY OVERVIEW
                  </Typography>
                </Box>

                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{ mb: 4, lineHeight: 1.8, fontWeight: 400 }}
                >
                  Transco Logistics is a leading transport company in The Kingdom of Eswatini. 
                  We provide added value services in road transport from any destination, 
                  either within or outside Eswatini.
                </Typography>

                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    border: `2px solid ${alpha(brandColors.green, 0.2)}`,
                    bgcolor: alpha(brandColors.green, 0.03),
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: 6,
                      height: '100%',
                      bgcolor: brandColors.green,
                    }
                  }}
                >
                  <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3, color: brandColors.black }}>
                    Our Goal
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    To develop customized high-quality, large scale transporting projects for our customers 
                    and provide a definite competitive advantage to all stakeholders involved.
                  </Typography>
                </Paper>

                <Box sx={{ mt: 4 }}>
                  <Typography variant="h6" gutterBottom fontWeight={700} sx={{ color: brandColors.black }}>
                    Key Advantages
                  </Typography>
                  <Stack spacing={2} sx={{ mt: 2 }}>
                    {[
                      "Fleet of fully maintained, clean trucks and trailers",
                      "C-tracking systems for security and safety management",
                      "Experienced and trained drivers for long and short distances",
                      "GPS devices for navigation in all locations",
                      "Competitive, reliable, and flexible service"
                    ].map((advantage, index) => (
                      <Box display="flex" alignItems="flex-start" gap={2} key={index}>
                        <CheckIcon sx={{ color: brandColors.green, mt: 0.5, flexShrink: 0 }} />
                        <Typography variant="body1" color="text.secondary">
                          {advantage}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              </Box>
            </Fade>
          </Grid>

          <Grid item xs={12} md={6}>
            <Zoom in timeout={800}>
              <Box>
                <Box display="flex" alignItems="center" gap={2} mb={4}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: 3,
                      bgcolor: brandColors.green,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: brandColors.white,
                      boxShadow: `0 8px 24px ${alpha(brandColors.green, 0.3)}`,
                    }}
                  >
                    <FlagIcon sx={{ fontSize: 32 }} />
                  </Box>
                  <Typography variant="h2" fontWeight={900} color={brandColors.black}>
                    VISION & MISSION
                  </Typography>
                </Box>

                {/* Vision Statement */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    border: `2px solid ${brandColors.orange}`,
                    bgcolor: alpha(brandColors.orange, 0.05),
                    position: "relative",
                    overflow: "hidden",
                    mb: 4,
                  }}
                >
                  <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3, color: brandColors.black }}>
                    Vision Statement
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    To establish ourselves as the best service provider in the transportation industry by 
                    providing the best service to our customers. This will help us to gain more respect 
                    from our customers hence developing successful and satisfied customers as well as employees.
                  </Typography>
                </Paper>

                {/* Mission Statement */}
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    border: `2px solid ${alpha(brandColors.green, 0.3)}`,
                    bgcolor: alpha(brandColors.black, 0.02),
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <Typography variant="h6" gutterBottom fontWeight={700} sx={{ mb: 3, color: brandColors.black }}>
                    Mission Statement
                  </Typography>
                  <Stack spacing={2}>
                    <Box display="flex" alignItems="flex-start" gap={2}>
                      <CheckIcon sx={{ color: brandColors.green, mt: 0.5, flexShrink: 0 }} />
                      <Typography variant="body1" color="text.secondary">
                        To provide customers with dependable transportation services based on fair pricing strategies
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap={2}>
                      <CheckIcon sx={{ color: brandColors.green, mt: 0.5, flexShrink: 0 }} />
                      <Typography variant="body1" color="text.secondary">
                        To be receptive to customers' needs and react in a professional and timely manner
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap={2}>
                      <CheckIcon sx={{ color: brandColors.green, mt: 0.5, flexShrink: 0 }} />
                      <Typography variant="body1" color="text.secondary">
                        To recognize customers, carriers and vendors as our first priority for continued success
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>
              </Box>
            </Zoom>
          </Grid>
        </Grid>
      </Container>

      {/* Our Values */}
      <Box
        sx={{
          position: "relative",
          py: { xs: 12, md: 18 },
          background: `linear-gradient(135deg, ${brandColors.black} 0%, ${alpha(brandColors.black, 0.95)} 100%)`,
          color: brandColors.white,
          overflow: "hidden",
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          <Fade in timeout={600}>
            <Box textAlign="center" mb={{ xs: 8, md: 12 }}>
              <Chip
                label="COMPANY VALUES"
                sx={{
                  mb: 4,
                  backgroundColor: alpha(brandColors.orange, 0.2),
                  color: brandColors.orange,
                  border: `1px solid ${alpha(brandColors.orange, 0.3)}`,
                  px: 3,
                  py: 1.5,
                  fontSize: "0.9rem",
                  fontWeight: 700,
                }}
              />
              <Typography
                variant="h2"
                gutterBottom
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "2.5rem", md: "3.5rem" },
                  background: `linear-gradient(135deg, ${brandColors.white} 0%, ${brandColors.green} 100%)`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  mb: 3,
                }}
              >
                Our Business Values
              </Typography>
              <Typography
                variant="h6"
                color="grey.300"
                sx={{
                  maxWidth: 800,
                  mx: "auto",
                  lineHeight: 1.6,
                  fontWeight: 400,
                }}
              >
                We recognize the benefit of flexibility in today's 24/7 global business environment 
                and implement flexible practices to accommodate our diverse client base.
              </Typography>
            </Box>
          </Fade>

          <Grid container spacing={{ xs: 4, md: 4 }}>
            {values.map((value, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Grow in timeout={(index + 1) * 300}>
                  <Card
                    sx={{
                      height: "100%",
                      borderRadius: 4,
                      border: `1px solid ${alpha(brandColors.white, 0.1)}`,
                      bgcolor: alpha(brandColors.white, 0.05),
                      backdropFilter: "blur(10px)",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      "&:hover": {
                        borderColor: brandColors.orange,
                        transform: "translateY(-12px)",
                        bgcolor: alpha(brandColors.white, 0.08),
                        boxShadow: `0 20px 40px ${alpha(brandColors.orange, 0.2)}`,
                        "& .value-icon": {
                          transform: "scale(1.1) rotate(5deg)",
                          bgcolor: index % 2 === 0 ? brandColors.orange : brandColors.green,
                        },
                      },
                    }}
                  >
                    <CardContent sx={{ p: { xs: 3, md: 4 }, textAlign: "center", height: '100%' }}>
                      <Box
                        className="value-icon"
                        sx={{
                          width: 80,
                          height: 80,
                          mx: "auto",
                          mb: 3,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: index % 2 === 0 ? brandColors.green : brandColors.orange,
                          borderRadius: "50%",
                          transition: "all 0.3s ease",
                          "& svg": {
                            fontSize: 36,
                            color: brandColors.white,
                          },
                        }}
                      >
                        {value.icon}
                      </Box>

                      <Typography variant="h5" gutterBottom color={brandColors.white} fontWeight={800} sx={{ mb: 2 }}>
                        {value.title}
                      </Typography>

                      <Typography
                        variant="body2"
                        color="grey.300"
                        sx={{ mb: 3, lineHeight: 1.6, minHeight: '4.8em' }}
                      >
                        {value.description}
                      </Typography>

                      <Divider sx={{ mb: 3, borderColor: alpha(brandColors.white, 0.1) }} />

                      <Stack spacing={1} alignItems="flex-start">
                        {value.features.map((feature, idx) => (
                          <Box
                            key={idx}
                            display="flex"
                            alignItems="center"
                            gap={1}
                            sx={{ width: '100%' }}
                          >
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                bgcolor: index % 2 === 0 ? brandColors.green : brandColors.orange,
                                flexShrink: 0,
                              }}
                            />
                            <Typography variant="caption" color="grey.400">
                              {feature}
                            </Typography>
                          </Box>
                        ))}
                      </Stack>
                    </CardContent>
                  </Card>
                </Grow>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Key Staff & Corporate Info */}
      <Container maxWidth="lg" sx={{ py: { xs: 12, md: 15 } }}>
        <Grid container spacing={{ xs: 4, md: 8 }}>
          {/* Key Staff */}
          <Grid item xs={12} md={8}>
            <Fade in timeout={600}>
              <Box>
                <Box display="flex" alignItems="center" gap={2} mb={4}>
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: 3,
                      bgcolor: brandColors.green,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: brandColors.white,
                      boxShadow: `0 8px 24px ${alpha(brandColors.green, 0.3)}`,
                    }}
                  >
                    <TeamIcon sx={{ fontSize: 32 }} />
                  </Box>
                  <Typography variant="h2" fontWeight={900} color={brandColors.black}>
                    KEY STAFF MEMBERS
                  </Typography>
                </Box>

                <Grid container spacing={3}>
                  {staff.map((person, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 3,
                          borderRadius: 3,
                          border: `2px solid ${alpha(person.color, 0.2)}`,
                          bgcolor: alpha(person.color, 0.05),
                          height: '100%',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            borderColor: person.color,
                            boxShadow: `0 12px 32px ${alpha(person.color, 0.15)}`,
                          }
                        }}
                      >
                        <Box
                          sx={{
                            width: 50,
                            height: 50,
                            borderRadius: '50%',
                            bgcolor: person.color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2,
                            color: brandColors.white,
                          }}
                        >
                          <PeopleIcon />
                        </Box>
                        <Typography variant="h6" fontWeight={700} color={brandColors.black} gutterBottom>
                          {person.role}
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, fontWeight: 500 }}>
                          {person.name}
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1}>
                          <PhoneIcon sx={{ fontSize: 16, color: person.color }} />
                          <Typography variant="body2" color="text.secondary">
                            {person.phone}
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>

                <Box sx={{ mt: 4 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                    Plus: 8 Drivers, 3 Operators, and 3 Mechanics
                  </Typography>
                </Box>
              </Box>
            </Fade>
          </Grid>

          {/* Corporate Information */}
          <Grid item xs={12} md={4}>
            <Zoom in timeout={800}>
              <Box>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: 4,
                    border: `2px solid ${brandColors.orange}`,
                    bgcolor: alpha(brandColors.orange, 0.05),
                    height: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      bgcolor: brandColors.orange,
                    }
                  }}
                >
                  <Typography variant="h5" gutterBottom fontWeight={900} sx={{ mb: 4, color: brandColors.black }}>
                    CORPORATE INFORMATION
                  </Typography>

                  <Stack spacing={3}>
                    {corporateInfo.map((info, index) => (
                      <Box key={index}>
                        <Box display="flex" alignItems="center" gap={2} sx={{ mb: 1 }}>
                          <Box
                            sx={{
                              width: 36,
                              height: 36,
                              borderRadius: '50%',
                              bgcolor: alpha(brandColors.green, 0.2),
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            {info.icon}
                          </Box>
                          <Typography variant="body2" color="text.secondary" fontWeight={600}>
                            {info.label}
                          </Typography>
                        </Box>
                        <Typography variant="body1" color={brandColors.black} fontWeight={600} sx={{ ml: 5 }}>
                          {info.value}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>

                  <Divider sx={{ my: 4, borderColor: alpha(brandColors.black, 0.1) }} />

                  {/* Address */}
                  <Box>
                    <Typography variant="h6" gutterBottom fontWeight={700} sx={{ color: brandColors.black, mb: 2 }}>
                      ADDRESS
                    </Typography>
                    <Stack spacing={1}>
                      <Box display="flex" alignItems="flex-start" gap={2}>
                        <LocationIcon sx={{ color: brandColors.green, mt: 0.5 }} />
                        <Box>
                          <Typography variant="body2" color="text.secondary" fontWeight={600}>
                            Physical Address
                          </Typography>
                          <Typography variant="body1" color={brandColors.black}>
                            Nsulutane MR33 Road towards MK111 International Airport
                          </Typography>
                        </Box>
                      </Box>
                      <Box display="flex" alignItems="flex-start" gap={2}>
                        <LocationIcon sx={{ color: brandColors.orange, mt: 0.5 }} />
                        <Box>
                          <Typography variant="body2" color="text.secondary" fontWeight={600}>
                            Postal Address
                          </Typography>
                          <Typography variant="body1" color={brandColors.black}>
                            P.O Box C2395, Hub Manzini, Eswatini
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Box>

                  <Button
                    variant="contained"
                    endIcon={<ArrowIcon />}
                    component="a"
                    href="/contact"
                    fullWidth
                    sx={{
                      mt: 4,
                      py: 2,
                      borderRadius: 3,
                      fontWeight: 700,
                      backgroundColor: brandColors.orange,
                      '&:hover': {
                        backgroundColor: alpha(brandColors.orange, 0.9),
                        transform: 'translateY(-2px)',
                        boxShadow: `0 8px 24px ${alpha(brandColors.orange, 0.3)}`,
                      },
                      transition: 'all 0.3s ease',
                    }}
                  >
                    Contact Us
                  </Button>
                </Paper>
              </Box>
            </Zoom>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default About;